import React from "react";
import { withRouter } from "react-router-dom";
import { observer, inject } from "mobx-react";
import Cookies from "js-cookie";
import configRouters from "Configs/routes";
import { sendMetriks } from "Services/sendMetriks";
import smoothScrollTo from "Helpers/Scroll";

@withRouter
@inject("ApplicationModel")
@observer
export default class RatesPopupHOC extends React.Component {
	openFirstPopup(data) {
		let {
			ApplicationModel: {
				windowSizeModel: { windowSizes },
			},
			match: { path },
		} = this.props;
		if (configRouters.RatesInHouse.route === path) {
			Cookies.set("connectTariffFrom", "from_popular_house");
		}
		if (windowSizes.xs) {
			sendMetriks("OPEN_QUIZ_MOBILE");
		} else if (windowSizes.sm) {
			sendMetriks("OPEN_QUIZ_TABLET");
		} else if (windowSizes.md || windowSizes.lg) {
			sendMetriks("OPEN_QUIZ_DESKTOP");
		}

		sendMetriks("OPEN_ORDER_FORM");
		let testABVariant = Cookies.get("AB_testtest__click_rates_popup1_from_quiz_send_phone");
		if (Boolean(testABVariant)) {
			sendMetriks("OPEN_QUIZ_TEST", [JSON.parse(testABVariant)?.name || "No_name"]);
		}

		this.closeModal();
		let modalModel = this.props.ApplicationModel.modalModel;
		let promise1 = import("Layouts/modalLayout");
		let promise2 = import("Containers/RatesFirstPopupContainer");
		Promise.all([promise1, promise2]).then((modules) => {
			let ModalLayout = modules[0].default;
			let RatesFirstPopupContainer = modules[1].default;
			modalModel.toggleModal(
				<ModalLayout authView={true} withoutClose={true} sendMetricksClickOutQuiz={true}>
					<RatesFirstPopupContainer closeModal={() => this.closeModal()} data={data} />
				</ModalLayout>
			);
		});
	}

	componentWillUnmount() {
		this.closeModal();
	}

	closeModal() {
		const modalModel = this.props.ApplicationModel.modalModel;
		if (modalModel.isOpen) {
			modalModel.toggleModal();
			if (this.props.ApplicationModel.tariffsModel.buttonTagRef) {
				let buttonTagRef = this.props.ApplicationModel.tariffsModel.buttonTagRef;
				let sizeButtonTag = buttonTagRef.offsetTop - 80;

				// Запускается 2 раза скролл, т.к. браузер не всегда нормально ставит скролл с первого раза.
				smoothScrollTo(0, sizeButtonTag);
				setTimeout(() => smoothScrollTo(0, sizeButtonTag), 1);
			}
		}
	}

	render() {
		let children = React.cloneElement(this.props.children, {
			openFirstPopup: (data) => this.openFirstPopup(data),
		});
		return children;
	}
}
